// extracted by mini-css-extract-plugin
export default {"disclaimerWell":"_e00a353a","disclaimerContainer":"_9359e26f","disclaimerContentContainer":"_9d676246","disclaimerCloseButton":"_d44ab48"};